export const ADMIN_LOGIN_URL = '/admin/login';
export const LOGIN_URL = '/login';

export enum UrlActionName {
  UPGRADE = 'upgrade',
  REACTIVATE = 'reactivate',
  CHANGE_CARD = 'change-card',
  GO_TO_STORE = 'store',
}
